const consent = {
    status: false,
    setStatus(_status) {
        this.status = _status;
    },
}

export default consent